"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DpItemAnalysisFactory = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var scoring_type_enum_1 = require("../../../../api/constants/scoring-type.enum");
var assessment_type_enum_1 = require("../../../../api/constants/assessment-type.enum");
var DpRubricAnalysis_1 = __importDefault(require("../RubricAnalysis/DpRubricAnalysis"));
var DpAssessmentAnalysis_1 = __importDefault(require("../AssessmentAnalysis/DpAssessmentAnalysis"));
var DpItemAnalysisFactory = function (_a) {
    var identifier = _a.identifier, assessment = _a.assessment, overallPerformance = _a.overallPerformance, overallRubricPerformance = _a.overallRubricPerformance, scoringType = _a.scoringType, openItemAnalysisModal = _a.openItemAnalysisModal;
    // --------------------------- Const
    var t = (0, react_i18next_1.useTranslation)('common').t;
    var assessmentTemplate = assessment.assessmentTemplate;
    // --------------------------- Methods
    var type = (0, react_1.useCallback)(function () {
        return !assessmentTemplate.hasRubricItems
            ? assessmentTemplate.isVocabularyAssignment
                ? assessment_type_enum_1.AssessmentType.Vocabulary
                : assessment_type_enum_1.AssessmentType.Assessment
            : assessmentTemplate.isNewRead
                ? scoring_type_enum_1.ScoringType.Passage
                : scoringType;
    }, [assessmentTemplate, scoringType]);
    var getItemAnalysis = (0, react_1.useMemo)(function () {
        switch (type()) {
            case scoring_type_enum_1.ScoringType.Matrix: {
                return ((0, jsx_runtime_1.jsx)(DpRubricAnalysis_1.default, { identifier: identifier, assessment: assessment, overallRubricPerformance: overallRubricPerformance, type: scoring_type_enum_1.ScoringType.Matrix, openItemAnalysisModal: openItemAnalysisModal }));
            }
            case scoring_type_enum_1.ScoringType.Rating: {
                return ((0, jsx_runtime_1.jsx)(DpRubricAnalysis_1.default, { identifier: identifier, assessment: assessment, overallRubricPerformance: overallRubricPerformance, type: scoring_type_enum_1.ScoringType.Rating, openItemAnalysisModal: openItemAnalysisModal }));
            }
            case scoring_type_enum_1.ScoringType.Passage:
            case assessment_type_enum_1.AssessmentType.Assessment: {
                return ((0, jsx_runtime_1.jsx)(DpAssessmentAnalysis_1.default, { assessment: assessment, overallPerformance: overallPerformance, openItemAnalysisModal: openItemAnalysisModal, scoringType: scoring_type_enum_1.ScoringType.Passage }));
            }
            case assessment_type_enum_1.AssessmentType.Vocabulary: {
                return ((0, jsx_runtime_1.jsx)(DpAssessmentAnalysis_1.default, { assessment: assessment, overallPerformance: overallPerformance, type: assessment_type_enum_1.AssessmentType.Vocabulary, scoringType: scoring_type_enum_1.ScoringType.Auto, openItemAnalysisModal: openItemAnalysisModal }));
            }
            default: {
                return (0, jsx_runtime_1.jsx)("div", { children: t('noReport') });
            }
        }
    }, [
        type,
        assessment,
        t,
        overallRubricPerformance,
        overallPerformance,
        identifier,
        openItemAnalysisModal,
    ]);
    return getItemAnalysis;
};
exports.DpItemAnalysisFactory = DpItemAnalysisFactory;
exports.default = exports.DpItemAnalysisFactory;
